__turbopack_context__.v({
  "h1": "styles-module__YsZtTa__h1",
  "h2": "styles-module__YsZtTa__h2",
  "h3": "styles-module__YsZtTa__h3",
  "h4": "styles-module__YsZtTa__h4",
  "title": "styles-module__YsZtTa__title",
});
